import { useEffect, useRef, useState } from 'react';
import moment from 'moment-timezone';
import { $windowSize } from 'ziphy-web-shared/basic/utils';
import { formatDate, formatDuration } from 'ziphy-web-shared/basic/utils/time';
import { $calendar } from '../Calendar.store';
export const usePreparedCardData = ({ date, data, itemBegin, itemEnd, }) => {
    const now = moment.tz($calendar.timezone);
    const today = now.clone().startOf('day');
    const slotsDay = $calendar.slots[date];
    const scheduleDay = $calendar.schedule[date];
    const begin = slotsDay[data.slotIndex].begin;
    const end = slotsDay[data.slotIndex + data.height - 1].end;
    const isFirstInDay = data.slotIndex === 0;
    const isLastInDay = slotsDay.length === data.slotIndex + data.height;
    const isPast = end.isBefore(now);
    const isMultiColumn = scheduleDay.maxCols > data.width;
    const cardStyles = {
        gridRowStart: data.slotIndex - $calendar.timeLimits.startIndex + 1,
        gridRowEnd: `span ${data.height}`,
        gridColumnStart: data.columnStart,
        gridColumnEnd: `span ${data.width}`,
    };
    const beginTime = formatDate(begin, 'time', $calendar.timezone);
    const duration = formatDuration({ from: begin, to: end }).asString;
    let prevDuration = '';
    let nextDuration = '';
    if (isFirstInDay && itemBegin) {
        itemBegin = moment.isMoment(itemBegin) ? itemBegin : moment(itemBegin).tz($calendar.timezone);
        const diff = begin.diff(itemBegin, 'seconds');
        if (diff)
            prevDuration = formatDuration({ seconds: diff }).asString;
    }
    if (isLastInDay && itemEnd) {
        itemEnd = moment.isMoment(itemEnd) ? itemEnd : moment(itemEnd).tz($calendar.timezone);
        const diff = itemEnd.diff(end, 'seconds');
        if (diff)
            nextDuration = formatDuration({ seconds: diff }).asString;
    }
    return {
        now,
        today,
        begin,
        end,
        isFirstInDay,
        isLastInDay,
        isPast,
        isMultiColumn,
        cardStyles,
        beginTime,
        duration,
        prevDuration,
        nextDuration,
    };
};
export const useCardMode = (cardData) => {
    const [mode, setMode] = useState(cardData.isMultiColumn ? 'small' : 'default');
    const ref = useRef(null);
    const refWidth = useRef(null);
    useEffect(() => {
        var _a, _b;
        if (!ref.current)
            return;
        refWidth.current = (_b = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()) === null || _b === void 0 ? void 0 : _b.width;
        setMode(refWidth.current < 100 ? 'small' : 'default');
    }, [$windowSize.width]);
    return { ref, mode, width: refWidth.current };
};
